import type { ComponentProps, HTMLAttributes, ReactNode } from "react";
import Button from "@imminently/decisively-ui/Button";
import Dialog from "@imminently/decisively-ui/Dialog";
import { cn } from "@/lib/utils";

export interface DialogAction extends Omit<ComponentProps<typeof Button>, "children" | "icon" | "label"> {
  name: string;
  label?: string;
  icon?: ReactNode;
}

export interface DialogActionsProps extends HTMLAttributes<HTMLDivElement> {
  primary: DialogAction;
  secondary?: DialogAction[];
}

const ActionButton = ({ name, label, icon, ...props }: DialogAction) => (
  <Button
    label={label ?? name}
    variant="contained"
    intent={props.intent ?? "primary"}
    {...props}
  >
    <>{icon}{name}</>
  </Button>
);

export const DialogActions = ({ primary, secondary = [], className, ...props }: DialogActionsProps) => (
  <Dialog.Actions className={cn("flex flex-row flex-nowrap items-center justify-end", className)} {...props}>
    {secondary.map((action) => (
      <ActionButton key={action.name} intent="secondary" {...action} />
    ))}
    <ActionButton {...primary} />
  </Dialog.Actions>
);
